import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=4f072b39&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f072b39')) {
      api.createRecord('4f072b39', component.options)
    } else {
      api.reload('4f072b39', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=4f072b39&", function () {
      api.rerender('4f072b39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XxwAyTtv83ZE/JS/comp/openstreetmap.vue"
export default component.exports